export default () => ({
  steps: [],
  trash: {
    steps: [],
    tasks: []
  }
})
